<template>
    <div class="configuration-detail flex-center">
        <img :src="iconSource" :alt="`Icon - ${name}`" :title="name" width="30" height="30" @mouseenter="Hover(true)" @mouseleave="Hover()"/>
        <span :id="`label-${index}`" class="label margin-l" style="width: 0;" v-show="showLabel || ShowMainLabel()">{{ name }}</span>
    </div>
</template>

<script>
import { Animation } from "@/assets/JS/Animation.js";
import $ from "jquery";

export default {
    name: "TimelineConfigurationDetail",
    props: {
        iconSource: String,
        name: String,
        index: Number,
        yBarExpanded: Boolean
    },
    data: () => ({ showLabel: false }),
    methods: {
        Hover: function(over) {
            if (this.name !== "Configurations") {
                if (over) {
                    this.showLabel = true;
                }
                const $label = $(`#label-${this.index}`);
                const value = over ? 100 : 0;
                const duration = over ? 300 : 100;
                const component = this;
                new Animation($label, "Width", value, duration, 0, function() {
                    if (!over) {
                        component.showLabel = false;
                    }
                });
            }
        },
        ShowMainLabel: function() {
            return this.name === "Configurations" && this.yBarExpanded;
        }
    }
};
</script>